import {
    getSearch,
    requestCreate,
    requestDelete,
    requestUpdate
} from "../api"
import {
    ADD_IN_LIST,
    REMOVE_IN_LIST,
    RESET_STATE,
    SET_LOADING,
    SET_LIST,
    UPDATE_IN_LIST,
    RESET_SEARCH_PARAMS,
    RESET_FORM
} from "../constant-types"
import {
    defaultAddInListMutation,
    defaultRemoveInListMutation,
    defaultSetListMutation,
    defaultSetLoading,
    defaultUpdateInListMutation
} from "../default-method"
import {
    getField,
    updateField
} from 'vuex-map-fields'

const createForm = (rootState) => ({
    ...rootState.productForm.rows[0],
    picture: rootState.pictureForm.pictures,
    new_picture: rootState.pictureForm.new_pictures.map(np => ({ caption: np.caption, file: np.file }))
})

const getDefaultState = () => {
    return {
        list: null,
        search_params: getDefaultSearchParamsState()
    }
}

const getDefaultSearchParamsState = () => {
    return {
        filter_search_text: '',
        loading: false,
        filter_sort: [{
            column: 'name',
            sort: 'asc',
            icon: ['fas', 'angle-up']
        }],
        filter_page: 1,
        filter_limit: 20,
        filter_category_id: 0,
        filter_type: 'goods',
    }
}

export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        ...defaultSetListMutation,
        ...defaultSetLoading,
        ...defaultAddInListMutation,
        ...defaultUpdateInListMutation,
        ...defaultRemoveInListMutation,
        [RESET_SEARCH_PARAMS](state) {
            state.search_params = getDefaultSearchParamsState();
        },
        updateField

    },
    // can async
    actions: {
        loadList({
            commit,
            state,
            getters
        }, payload = {
            resetPage: false
        }) {
            if (payload.resetPage) {
                commit('updateField', {
                    path: 'search_params.filter_page',
                    value: 1
                })
            }
            commit(SET_LOADING, true)
            let filterMust = []
            filterMust.push([state.search_params.filter_type, "=", "", "type"])
            if (state.search_params.filter_category_id > 0) {
                filterMust.push([state.search_params.filter_category_id, "=","", "category_id"])
            }

            return getSearch({
                    words: _.split(state.search_params.filter_search_text, ' '),
                    fields: ['name']
                },
                
                    filterMust
                ,
                [],
                state.search_params.filter_sort,
                state.search_params.filter_page,
                state.search_params.filter_limit,
                ['category.categoryClass:id,name','unit'],
                [],
                'product',
                (response) => commit(SET_LIST, response),
                () => {},
                () => {
                    commit(SET_LOADING, false)
                }
            )
        },
        requestCreateProduct({
            commit,
            rootState
        }) {
            requestCreate('product', createForm(rootState), commit, ADD_IN_LIST)
        },
        requestUpdateProduct({
            commit,
            rootState
        }) {
            requestUpdate(`product/${rootState.productForm.rows[0].id}`, createForm(rootState), commit, UPDATE_IN_LIST)
        },
        requestDeleteProduct({
            commit,
            rootState
        }, product) {
            requestDelete(`product/${product.id}`, {}, commit, product.name, REMOVE_IN_LIST)
        },
        setForm({commit}, product) {
            commit('productForm/SET_FORM', _.omit(product, ['picture']), { root: true})
            // set picture, if have
            if (product.picture) {
                commit('pictureForm/SET_FORMS', [product.picture], { root: true})
            }
        },
        resetForm({state, commit}) {
            commit('productForm/RESET_FORM', null, { root: true})
            commit('pictureForm/RESET_FORM', null, { root: true})
        }

    },
    // call variable with custom display
    getters: {
        getField
    },
})
